var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-qr", {
    ref: "Qrcode",
    style: _vm.qrStyle,
    attrs: {
      "logo-src": _vm.normalizedLogoSrc,
      size: _vm.renderSize,
      "correct-level": _vm.correctLevel,
      "logo-scale": 0.3,
      "auto-color": true,
      "logo-corner-radius": 5,
      "logo-margin": 1,
      margin: 3,
      "dot-scale": 1,
      text: _vm.appSrc,
      callback: _vm.qrBack,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }